import { useObserver } from "mobx-react";
import Select from "./Select";
import { useState } from "react";
import { useStores } from "../../store";
import Experience from "./experience";
import Input from "./input";

export default function Pay(props) {
  const [showPayBy, setShowPayBy] = useState(props.showPayBy ?? "range");
  const { RecuiterStore } = useStores();

  return useObserver(() => (
    <div className="w-full py-6 md:py-2 md:pt-6">
      <h1 className="text-lg font-sans mb-6">Salary details</h1>

      <div className="flex items-center gap-2 mb-4">
        <input
          type="checkbox"
          checked={props.isSalaryDisclosed || false}
          onChange={(e) => {
            props.setIsSalaryDisclosed(e.target.checked);
          }}
          className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
        />
        <label className="text-sm font-medium text-gray-700 cursor-pointer">
          This is an unpaid job
        </label>
      </div>

      {!props.isSalaryDisclosed && (
        <div className="flex flex-col md:flex-row gap-6">
          {/* Pay type selector */}
          <div className="w-full md:w-full">
            <Select
              label="Salary payed in"
              required={true}
              value={props.showPayBy}
              height="h-[2.5rem]"
              action={(e) => {
                setShowPayBy(e.target.value);
                props.setShowPayBy(e);
              }}
              placeholder="Select method Range/Exact Amount"
              options={[
                { label: "Exact amount", value: "exactAmount" },
                { label: "Range", value: "range" },
              ]}
            />
          </div>

          {/* Currency selector */}
          <div className="w-full md:w-full">
            <span className="flex flex-col gap-2">
              <label className="font-sans text-base text-[#6D6B6B]">
                Currency
              </label>
              <select
                value={props.currency || ""}
                required
                onChange={(e) => props.setCurrency(e)}
                className="w-full border px-4 rounded-lg h-[2.5rem] border-[#c9c9c9] text-[15px] text-gray-500"
              >
                <option value="" disabled hidden>
                  Select currency
                </option>
                <option value="₹ India">₹ India</option>
                <option value="$ USA">$ USA</option>
                <option value="€ Europe">€ Europe</option>
                <option value="UGX Uganda">UGX Uganda</option>
              </select>
            </span>
          </div>

          {/* Salary input/range */}
          <div className="w-full md:w-full">
            {showPayBy === "exactAmount" ? (
              <Input
                label="Salary"
                type="number"
                unres="true"
                height="h-[2.5rem]"
                width="w-full"
                currency={props.currency}
                regex={true}
                defaultValue={
                  RecuiterStore.jobPostDetails.basicJobDetails.salary.min
                }
                regexFormula={/^[0-9]*$/}
                placeholder="Enter salary"
                min={props.min}
                action={(e) => {
                  props.setMinSalary(e);
                }}
              />
            ) : (
              <Experience
                label="Salary"
                value1={RecuiterStore.jobPostDetails.basicJobDetails.salary.min}
                value2={RecuiterStore.jobPostDetails.basicJobDetails.salary.max}
                currency={props.currency}
                hide={true}
                salary={true}
                action1={(e) => {
                  RecuiterStore.jobPostDetails.basicJobDetails.salary.min =
                    e.target.value;
                }}
                action2={(e) => {
                  RecuiterStore.jobPostDetails.basicJobDetails.salary.max =
                    e.target.value;
                }}
              />
            )}
          </div>

          {/* Rate selector */}
          <div className="w-full md:w-full">
            <Select
              label="Rate"
              height="h-[2.5rem]"
              required={true}
              value={RecuiterStore.jobPostDetails.basicJobDetails.salary.rate}
              action={(e) => {
                RecuiterStore.jobPostDetails.basicJobDetails.salary.rate =
                  e.target.value;
              }}
              placeholder="Select"
              options={[
                { label: "Per Hour", value: "perHour" },
                { label: "Per Day", value: "perDay" },
                { label: "Per Month", value: "perMonth" },
                { label: "Per Annum", value: "perYear" },
              ]}
            />
          </div>
        </div>
      )}
    </div>
  ));
}
